<template>
  <div class="wf-page">
    <div class="wf-page-head">
      <el-input
        v-model="query.condition.formName"
        size="small"
        placeholder="搜索表单名称"
        style="width: 220px"
        clearable
        @keyup.enter.native="reload"
      />
      <el-button size="small" icon="el-icon-search" @click="reload">查询</el-button>
      <el-button size="small" type="primary" icon="el-icon-plus" @click="openDesigner(null)">新建表单</el-button>
    </div>

    <el-table :data="list" v-loading="loading" size="small" border style="width: 100%">
      <el-table-column prop="formName" label="表单名称" min-width="180" />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="statusType(row.status)">{{ statusText(row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="version" label="版本" width="70" align="center" />
      <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
      <el-table-column prop="updateTime" label="更新时间" width="160" />
      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" size="mini" @click="openDesigner(row.id)">设计</el-button>
          <el-button type="text" size="mini" style="color:#F56C6C" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="wf-pager"
      background
      layout="total, prev, pager, next"
      :total="total"
      :current-page="query.page"
      :page-size="query.limit"
      @current-change="onPage"
    />

    <el-dialog
      :title="editingId ? '编辑表单' : '新建表单'"
      :visible.sync="designerVisible"
      fullscreen
      :close-on-click-modal="false"
      append-to-body
    >
      <WflowFormDesigner
        v-if="designerVisible"
        :form-id="editingId"
        @saved="onSaved"
        @cancel="designerVisible = false"
      />
    </el-dialog>
  </div>
</template>

<script>
import WflowFormDesigner from './WflowFormDesigner.vue'
import { listForm, deleteForm } from '@/api/wflow/form'

export default {
  name: 'WflowFormList',
  components: { WflowFormDesigner },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      query: { page: 1, limit: 10, condition: { formName: '' } },
      designerVisible: false,
      editingId: null
    }
  },
  created() {
    this.reload()
  },
  methods: {
    reload() {
      this.query.page = 1
      this.load()
    },
    load() {
      this.loading = true
      listForm(this.query).then(res => {
        this.loading = false
        if (res && res.code === 200 && res.data) {
          this.list = res.data.records || []
          this.total = res.data.total || 0
        }
      }).catch(() => { this.loading = false })
    },
    onPage(p) {
      this.query.page = p
      this.load()
    },
    openDesigner(id) {
      this.editingId = id
      this.designerVisible = true
    },
    onSaved() {
      this.designerVisible = false
      this.load()
    },
    remove(row) {
      this.$confirm('确认删除表单「' + row.formName + '」？', '提示', { type: 'warning' })
        .then(() => deleteForm(row.id))
        .then(res => {
          if (res && res.code === 200) {
            this.$message.success('已删除')
            this.load()
          }
        }).catch(() => {})
    },
    statusText(s) {
      return { 0: '草稿', 1: '已发布', 2: '停用' }[s] || '草稿'
    },
    statusType(s) {
      return { 0: 'info', 1: 'success', 2: 'warning' }[s] || 'info'
    }
  }
}
</script>

<style scoped>
.wf-page {
  padding: 4px;
}
.wf-page-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}
.wf-pager {
  margin-top: 12px;
  text-align: right;
}
</style>
